(function (root) {
  'use strict';
  var choices = ['24-50', 24, 35, 50, 85, 135];
  function choiceValue(value) { return String(value) === '24-50' ? '24-50' : Number(value); }
  function choiceOrder(a, b) { return choices.indexOf(a) - choices.indexOf(b); }
  function normalized(value) { return String(value == null ? '' : value).normalize('NFKC').trim().toLowerCase(); }
  function optics(product) {
    var texts = [product.title || ''];
    (product.options || []).forEach(function (option) {
      if (/focal|ระยะ.*(?:เลนส์|โฟกัส)|ทางยาว/.test(normalized(option.name))) texts.push((option.values || []).join(' / '));
    });
    var singles = new Set(), ranges = [];
    texts.forEach(function (text) {
      var re = /(?<![\d.])(\d+(?:\.\d+)?(?:\s*[\/+–-]\s*\d+(?:\.\d+)?)*)(?:\s*)(?:mm|มม\.?)(?![a-z])/gi;
      var match;
      while ((match = re.exec(String(text).normalize('NFKC')))) {
        (match[1].match(/\d+(?:\.\d+)?/g) || []).forEach(function (n) { singles.add(Number(n)); });
        var pair, rr = /(\d+(?:\.\d+)?)\s*[-–]\s*(\d+(?:\.\d+)?)/g;
        while ((pair = rr.exec(match[1]))) ranges.push([Number(pair[1]), Number(pair[2])]);
      }
    });
    return { singles: singles, ranges: ranges };
  }
  function hasFocal(product, focal) {
    var result = product.optics || optics(product), value = Number(focal);
    // The range choice is a zoom range, not a group of prime focal lengths.
    if (focal === '24-50') return result.ranges.some(function (r) { return r[0] === 24 && r[1] === 50; });
    return result.singles.has(value) || result.ranges.some(function (r) { return r[0] <= value && value <= r[1]; });
  }
  function selected(params) {
    return Array.from(new Set((params.get('lnw_focal') || '').split(',').map(choiceValue).filter(function (n) { return choices.indexOf(n) !== -1; }))).sort(choiceOrder);
  }
  function matchesFocals(product, lengths) { return !lengths.length || lengths.some(function (n) { return hasFocal(product, n); }); }
  function matchesFocalsInContext(product, lengths, params) {
    if (!matchesFocals(product, lengths)) return false;
    if (!lengths.length) return true;
    var variants = product.variants || [], focalVariants = variants.filter(function (v) {
      return Object.keys(v.options || {}).some(function (name) { return /focal|ระยะ.*(?:เลนส์|โฟกัส)|ทางยาว/.test(normalized(name)); });
    });
    if (!focalVariants.length) return true;
    var variantParams = new URLSearchParams();
    params.forEach(function (value, name) { if (name.indexOf('filter.v.') === 0) variantParams.append(name, value); });
    return focalVariants.some(function (v) {
      var focal = Object.keys(v.options).find(function (name) { return /focal|ระยะ.*(?:เลนส์|โฟกัส)|ทางยาว/.test(normalized(name)); });
      return matchesFocals({ title: v.options[focal] }, lengths) && matchesNative({ variants: [v] }, variantParams);
    });
  }
  function values(value) {
    return (Array.isArray(value) ? value : [value]).filter(function (v) { return v != null; }).map(normalized);
  }
  function matchesNative(product, params, except) {
    var filters = new Map();
    params.forEach(function (value, key) {
      if (key.indexOf('filter.') !== 0 || key === except) return;
      if (except === 'filter.v.price' && key.indexOf('filter.v.price.') === 0) return;
      if (!filters.has(key)) filters.set(key, []);
      filters.get(key).push(normalized(value));
    });
    var variantFilters = [];
    for (var entry of filters) {
      var key = entry[0], wanted = entry[1];
      if (key.indexOf('filter.v.') === 0) { variantFilters.push(entry); continue; }
      var available = values((product.facets || {})[key]);
      if (!wanted.some(function (v) { return available.indexOf(v) !== -1; })) return false;
    }
    if (!variantFilters.length) return true;
    return (product.variants || []).some(function (variant) {
      return variantFilters.every(function (entry) {
        var key = entry[0], wanted = entry[1];
        if (key === 'filter.v.availability') return wanted.indexOf(variant.available ? '1' : '0') !== -1;
        if (key === 'filter.v.price.gte') return variant.price >= Number(wanted[0]) * 100;
        if (key === 'filter.v.price.lte') return variant.price <= Number(wanted[0]) * 100;
        if (key.indexOf('filter.v.option.') === 0) return wanted.indexOf(normalized((variant.options || {})[key.slice(16)])) !== -1;
        if (key.indexOf('filter.v.m.') === 0) return wanted.some(function (value) { return values((variant.facets || {})[key]).indexOf(value) !== -1; });
        return false;
      });
    });
  }
  root.lnwFocalCore = Object.freeze({ choices: choices, choiceValue: choiceValue, choiceOrder: choiceOrder, optics: optics, hasFocal: hasFocal, selected: selected, matchesFocals: matchesFocals, matchesNative: matchesNative, matchesFocalsInContext: matchesFocalsInContext });
}(typeof window !== 'undefined' ? window : globalThis));
